import { Controller } from 'stimulus';
import mapboxgl from 'mapbox-gl';

const accessToken = 'pk.eyJ1IjoidmlsbHUxNjQiLCJhIjoiY2s3aml6MWhvMDRsNTNrcnZrMGduYW9sdCJ9.VLy3hgMWeRCW4WhjLx64Bw';

function initMapElement(el) { // eslint-disable-line class-methods-use-this
  let elementOptions = el.dataset.options;
  elementOptions = elementOptions ? JSON.parse(elementOptions) : {};
  const defaultOptions = {
    container: el,
    style: 'mapbox://styles/mapbox/light-v9',
    scrollZoom: false,
    interactive: false,
  };
  const options = Object.assign(defaultOptions, elementOptions);

  // Get access token
  mapboxgl.accessToken = accessToken;

  // Init map
  new mapboxgl.Map(options);
}

export default class extends Controller {
  connect() { // eslint-disable-line class-methods-use-this
    const map = document.querySelectorAll('[data-toggle="map"]');
    console.log(mapboxgl);
    Array.from(map).forEach((el) => {
      initMapElement(el);
    });
  }
}
